import { Injectable, signal, WritableSignal } from '@angular/core';

export enum FoldersAPILoadingState {
    INIT,
    LOADING,
    LOADED,
    ERROR
}

export enum FoldersAPICall {
    DELETE_FOLDER = 'deleteFolder',
    GET_ALL_USER_FOLDERS = 'getAllUserFolders',
    SAVE_FOLDER = 'saveFolder',
    SET_REPORT_FOLDER = 'setReportFolder',
    SET_SCHEDULE_FOLDER = 'setScheduleFolder'
}

@Injectable({
    providedIn: 'root'
})
export class UserFoldersApiSignalService {
    private loadingStates: { [K in FoldersAPICall]: WritableSignal<FoldersAPILoadingState> } = {
        deleteFolder: signal(FoldersAPILoadingState.INIT),
        getAllUserFolders: signal(FoldersAPILoadingState.INIT),
        saveFolder: signal(FoldersAPILoadingState.INIT),
        setReportFolder: signal(FoldersAPILoadingState.INIT),
        setScheduleFolder: signal(FoldersAPILoadingState.INIT)
    };

    /**
     * Sets the fetch state of a request
     * @param call request type
     * @param state state to set
     */
    setLoadingState(call: FoldersAPICall, state: FoldersAPILoadingState) {
        this.loadingStates[call].set(state);
    }

    /**
     * Gets the state of a request
     * @param call request type
     * @returns current state
     */
    getLoadingState(call: FoldersAPICall): FoldersAPILoadingState {
        return this.loadingStates[call]();
    }
}
